<script>
import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"
</script>


<StandardHeader />

<div class="pageContent">
<iframe src="https://www.termsfeed.com/live/abd66956-532d-4cb3-b5dc-3247cee9dd34" width="100%" height="900px" frameBorder="0">

<iframe>
</div>



<StandardFooter />
<style>
.pageContent{margin-left:90px ; margin-right: 90px}
</style>
